var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { wrapDispatch } from "../Multireducer";
import { NeedAuthorization } from "../Auth";
import { I18NLink, I18NMenu, t, Translate } from "../I18N";
import { processFilters, encodeSearch } from "../Library/actions/libraryActions";
import { showSemanticSearch } from "../SemanticSearch/actions/actions";
import { FeatureToggleSemanticSearch } from "../SemanticSearch/components/FeatureToggleSemanticSearch";
import { libraryViewInfo } from "./libraryViewInfo";
import { Icon } from "../UI";
import { actions } from "../BasicReducer";
import { store } from "../store";
import { DropdownMenu } from "./DropdownMenu";

class Menu extends Component {
  libraryUrl() {
    const { location, librarySearch, libraryFilters, defaultLibraryView } = this.props;
    const { searchTerm } = location.query;
    const params = processFilters(librarySearch, libraryFilters.toJS());
    params.searchTerm = searchTerm;

    return `/${libraryViewInfo[defaultLibraryView].url}/${encodeSearch(params)}`;
  }

  render() {
    const { links, defaultLibraryView } = this.props;
    const user = this.props.user.toJS();

    const navLinks = links.map((link, index) => {
      const type = link.get('type') || 'link';

      if (type === 'link') {
        const url = link.get('url') || '/';
        if (url.startsWith('http')) {
          return /*#__PURE__*/(
            _jsx("li", { className: "menuNav-item" }, link.get('_id'), /*#__PURE__*/
            _jsx("a", { href: url, className: "btn menuNav-btn", target: "_blank", rel: "noreferrer" }, void 0,
            t('Menu', link.get('title')))));



        }
        return /*#__PURE__*/(
          _jsx("li", { className: "menuNav-item" }, link.get('_id'), /*#__PURE__*/
          _jsx(I18NLink, { to: url, className: "btn menuNav-btn", activeClassName: "active-link" }, void 0,
          t('Menu', link.get('title')))));



      }

      return /*#__PURE__*/_jsx(DropdownMenu, { link: link, position: index }, index);
    });

    return /*#__PURE__*/(
      _jsx("ul", { className: this.props.className }, void 0, /*#__PURE__*/
      _jsx("li", { className: "menuItems", onClick: this.props.onClick }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "menuNav-list" }, void 0, navLinks)), /*#__PURE__*/

      _jsx(I18NMenu, {}), /*#__PURE__*/
      _jsx("li", { className: "menuActions mobile-menuActions", onClick: this.props.onClick }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "menuNav-list" }, void 0, /*#__PURE__*/
      _jsx(FeatureToggleSemanticSearch, {}, void 0, /*#__PURE__*/
      _jsx("li", { className: "menuNav-item semantic-search" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: this.props.showSemanticSearch,
        className: "menuNav-btn btn btn-default",
        "aria-label": t('System', 'Semantic search', null, false) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "flask" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Semantic search"))))), /*#__PURE__*/




      _jsx("li", { className: "menuNav-item" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, {
        to: this.libraryUrl(),
        onClick: () => store.dispatch(actions.set('library.sidepanel.view', 'library')),
        className: "menuNav-btn btn btn-default public-documents",
        activeClassName: "active-link",
        "aria-label": t('System', 'Library', null, false) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: libraryViewInfo[defaultLibraryView].icon }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Library")))), /*#__PURE__*/



      _jsx(NeedAuthorization, { roles: ['admin', 'editor', 'collaborator'] }, void 0, /*#__PURE__*/
      _jsx("li", { className: "menuNav-item only-desktop" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, {
        to: "/settings/account",
        className: "menuNav-btn btn btn-default settings-section",
        activeClassName: "active-link",
        "aria-label": t('System', 'Settings', null, false) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "cog" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Settings"))))), /*#__PURE__*/




      _jsx(NeedAuthorization, { roles: ['admin', 'editor', 'collaborator'] }, void 0, /*#__PURE__*/
      _jsx("li", { className: "menuNav-item only-mobile" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, {
        to: "/settings/",
        className: "menuNav-btn btn btn-default settings-section",
        activeClassName: "active-link",
        "aria-label": t('System', 'Settings', null, false) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "cog" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Settings"))))), /*#__PURE__*/




      _jsx(NeedAuthorization, { roles: ['admin', 'editor', 'collaborator'] }, void 0, /*#__PURE__*/
      _jsx("li", { className: "menuNav-item only-mobile" }, void 0, /*#__PURE__*/
      _jsx("a", { href: "/logout", className: "menuNav-btn btn btn-default" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "power-off" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Logout"))))),




      (() => {
        if (!user._id) {
          return /*#__PURE__*/(
            _jsx("li", { className: "menuNav-item" }, void 0, /*#__PURE__*/
            _jsx(I18NLink, {
              to: "/login",
              className: "menuNav-btn btn btn-default",
              "aria-label": t('System', 'Sign in', null, false) }, void 0, /*#__PURE__*/

            _jsx(Icon, { icon: "power-off" }), /*#__PURE__*/
            _jsx("span", { className: "tab-link-label" }, void 0, /*#__PURE__*/
            _jsx(Translate, {}, void 0, "Sign in")))));




        }

        return null;
      })()))));




  }
}

Menu.defaultProps = {
  showSemanticSearch: () => {},
  defaultLibraryView: 'cards'
};













function mapStateToProps({ user, settings, library, uploads }) {
  return {
    user,
    librarySearch: library.search,
    libraryFilters: library.filters,
    uploadsSearch: uploads.search,
    uploadsFilters: uploads.filters,
    uploadsSelectedSorting: uploads.selectedSorting,
    links: settings.collection.get('links'),
    defaultLibraryView: settings.collection.get('defaultLibraryView')
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
  {
    showSemanticSearch
  },
  wrapDispatch(dispatch, 'library'));

}

export { Menu, mapStateToProps, mapDispatchToProps };
export default connect(mapStateToProps, mapDispatchToProps)(Menu);